import { render, staticRenderFns } from "./addSubDepartment.vue?vue&type=template&id=c19f2b6a&scoped=true"
import script from "./addSubDepartment.vue?vue&type=script&lang=js"
export * from "./addSubDepartment.vue?vue&type=script&lang=js"
import style0 from "./addSubDepartment.vue?vue&type=style&index=0&id=c19f2b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19f2b6a",
  null
  
)

export default component.exports